exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Loading-spinner {\n  margin: 40px 0;\n  padding: 30px 50px;\n}", ""]);

